import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

const mapTrial = (el) => ({
    ...el,
    geometry: [[el.longitude, el.latitude]],
    iconType: 'trialCorn',
    _id: el.id,
});

export const getFieldTrialsFromAPI = async ({ countryCode = 'AR', page = 1, pageSize = 100 }) => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/trial-fields/?country_code=${countryCode}&page=${page}&page_size=${pageSize}`,
        window.location.origin
    );

    const res = await axFetch.get(apiUrl.toString());
    return {
        ...res.data,
        results: res.data.results.map(mapTrial),
    };
};

export const getFieldTrialsTypesFromAPI = async ({
    page = 1,
    pageSize = 100,
}: {
    page?: number;
    pageSize?: number;
}) => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/trial-fields/types/?page=${page}&page_size=${pageSize}`,
        window.location.origin
    );
    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};
